const paramMapping = {
  findAppointments: ["practiceId", "firstName", "lastName", "patientId", "phoneNumber"],
  latestAvaiableAppointments: ["practiceId", "startDate", "endDate"],
  availableAppointmentsOfDoctor: ["practiceId", "doctorCode", "startDate", "endDate"],
  addBooking: ["practiceId", "firstName", "lastName", "dateOfBirth", "phoneNumber", "doctorCode", "date", "length", "appointmentType"],
  confirmAppointment: ["practiceId", "appointmentId"],
  cancelAppointment: ["practiceId", "appointmentId"],
  checkinAppointment: ["practiceId", "appointmentId"],
  findPatients: ["practiceId", "phoneNumber"],
  findInvoices: ["practiceId", "firstName", "lastName", "dateOfBirth", "phoneNumber"],
  emailInvoice: ["practiceId", "invoiceId"],
};

const getPracticeId = () => {
  try {
    return localStorage.getItem("practiceId");
  } catch {
    return null;
  }
};

export const requestApi = async (name, ...args) => {
  let params = {};

  // ✅ Object-style call
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null) {
    params = { ...args[0] };
  } else {
    // ✅ Positional mapping (no _ignore needed anymore)
    const names = paramMapping[name] || [];
    args.forEach((val, idx) => {
      const paramName = names[idx];
      if (paramName) {
        params[paramName] = val;
      }
    });
  }

  // ✅ Extract practiceId
  let { practiceId, ...restParams } = params;

  // ✅ Fallback
  if (!practiceId) {
    practiceId = getPracticeId();
  }

  // ✅ Enforce requirement
  if (!practiceId) {
    throw new Error(`practiceId is required for API "${name}"`);
  }

  const response = await fetch(`/server/worker/api/${name}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      practiceId,
      params: restParams,
    }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`API error (${response.status}): ${text}`);
  }

  return response.json();
};
